import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  cancelActiveChip,
  cancelProposedChip,
  proposeAvailableChip,
  restoreCancelledChip,
} from "core-integration/src/store/chips/actions";
import {
  getActiveChip,
  getActiveOrProposedAllChipName,
  getActiveOrProposedTeamChipName,
  getPotentialChips,
  teamChipsHaveChanged,
} from "core-integration/src/store/chips/reducers";
import { IPotentialChip } from "core-integration/src/store/chips/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import {
  IElement,
  IElementsById,
} from "core-integration/src/store/elements/types";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { fetchEntrySummary } from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import {
  getCurrentEvent,
  getEventsById,
  getNextEvent,
} from "core-integration/src/store/events/reducers";
import { getFixturesForNextEventByTeam } from "core-integration/src/store/fixtures/reducers";
import { IFixturesForEventByTeam } from "core-integration/src/store/fixtures/types";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { changeCaptain } from "core-integration/src/store/my-team/actions";
import {
  getMyFormation,
  getMyPicksProposed,
  getMyTeamSavingState,
  hasMyTeamChanged,
  isMyTeamValid,
} from "core-integration/src/store/my-team/reducers";
import {
  actionSubstitution,
  fetchMyTeam,
  saveMyTeam,
} from "core-integration/src/store/my-team/thunks";
import { IPickProposed } from "core-integration/src/store/my-team/types";
import { getPhases } from "core-integration/src/store/phases/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import {
  formatRawAsISO,
  formatRawAsLocalI18n,
} from "core-integration/src/utils/datetime";
import { range } from "lodash";
import React, { useEffect, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "rebass/styled-components";
import styled from "styled-components";
import { dateLocales } from "../../i18n";
import ArrowRight from "../../img/icons/arrow-right.svg?react";
import InfoIcon from "../../img/icons/info.svg?react";
import { ChipName, getAllChipDetails } from "../../utils/chips";
import { getPrefixedEventShortName } from "../../utils/events";
import { createInteractionData, createPageViewData } from "../../utils/tealium";
import Alert from "../Alert";
import Button from "../Button";
import DeadlineBar from "../DeadlineBar";
import Dialog, { DialogButtonItem } from "../Dialog";
import Entry from "../Entry";
import { FixturesForElement } from "../FixtureForElement";
import Fixtures from "../Fixtures";
import { Main, Secondary, Wrapper } from "../Layout";
import Link from "../Link";
import Tooltip from "../Tooltip";
import { BoxWrapStyles } from "../Utils";
import DreamTeam from "../icons/DreamTeam";
import SquadActionBar from "../squad/SquadActionBar";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import BenchUnit from "./BenchUnit";
import ChipStatus from "./ChipStatus";
import MyTeamTable from "./MyTeamTable";
import PitchFormation from "./PitchFormation";
import TeamElementGroup from "./TeamElementGroup";
import { BenchElements } from "./styles";
import NbaNewsProvider from "../news/NbaNewsProvider";

const TableWrap = styled.div`
  ${BoxWrapStyles};
`;

const DeadlineBarWrap = styled.div`
  margin: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[2]};
  border-top: ${(props) => props.theme.borders[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: ${({ theme }) => theme.space[2]};
  }
`;

const ChipSectionWrap = styled.div`
  display: flex;
  justify-content: center;
`;

const ChipSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  width: 100%;
  margin: ${({ theme }) => theme.space[2]} 0 ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => theme.space[2]};
  list-style-type: none;
  ${BoxWrapStyles};
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.secondary};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    margin: ${({ theme }) =>
      `${theme.space[2]} ${theme.space[2]} ${theme.space[3]}`};
    border-radius: ${({ theme }) => theme.space[2]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin: ${({ theme }) => theme.space[2]} 0 ${({ theme }) => theme.space[3]};
  }
`;

const HeadingInfo = styled.div`
  flex: 0.5 180px;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 0.5 190px;
  }
`;

const ChipHeading = styled.h3`
  margin: ${({ theme }) => theme.space[2]} 0;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: 600;
  text-align: left;
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[1]};
  }
`;

const ButtonHeight = styled.div`
  flex: 1 120px;
  max-width: 300px;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    flex: 1 180px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 1 190px;
  }
`;

const ChipLinkWrap = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[1]};
`;

const ChipLink = styled(Link)`
  position: relative;
  display: block;
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[2]};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.greyBlue};
  color: #333;
  text-transform: capitalize;

  &:hover {
    text-decoration: none;
  }
`;

const ChipLinkArrow = styled(ArrowRight)`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.space[2]};
  transform: translateY(-50%);
  fill: currentColor;
  cursor: pointer;
`;

const renderPickValue =
  (initProps: {
    elementsById: IElementsById;
    fixturesForNextEventByTeam: IFixturesForEventByTeam;
    teamsById: ITeamsById;
  }) =>
  (pick: IPickLight) => {
    const element = initProps.elementsById[pick.element];
    return (
      <FixturesForElement
        myTeam={true}
        fixtures={initProps.fixturesForNextEventByTeam[element.team]}
        element={element}
        teamsById={initProps.teamsById}
      />
    );
  };

const PlayerActions = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: 50%;
    margin: 0 auto;
  }
`;

const Note = styled.p`
  color: #6c6c6c;
  text-align: center;
`;

type Props = WithTranslation;

const MyTeam = ({ i18n, t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const [pickForMenu, setPickForMenu] = useState<IPickProposed | null>(null);
  const player = useSelector(getPlayerData) as ILoggedInPlayer;
  const activeChip = useSelector(getActiveChip);
  const chipInPlayName = useSelector(getActiveOrProposedTeamChipName);
  const chipAllPlayName = useSelector(getActiveOrProposedAllChipName);
  const changed = useSelector(hasMyTeamChanged);
  const chips = useSelector(getPotentialChips);
  const chipsChanged = useSelector(teamChipsHaveChanged);
  const elementsById = useSelector(getElementsById);
  const entry = useSelector((state: RootState) =>
    getEntry(state, player.entry),
  );
  const fixturesForNextEventByTeam = useSelector(getFixturesForNextEventByTeam);
  const formation = useSelector(getMyFormation);
  const now = useSelector(getCurrentEvent);
  const nextEvent = useSelector(getNextEvent);
  const phases = useSelector(getPhases);
  const picks = useSelector(getMyPicksProposed);

  const savingState = useSelector(getMyTeamSavingState);
  const rules = useSelector(getRules) as IRules;
  const teamsById = useSelector(getTeamsById);
  const valid = useSelector(isMyTeamValid);
  const eventsById = useSelector(getEventsById);

  const handleShowMenuForPickElement = (element: number) => {
    const matches = picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsById[pick.element].in_dreamteam ? (
      <Link to="/dream-team/">
        <DreamTeam />
      </Link>
    ) : null;

  const action = (type: "substitute" | "makeCaptain", element: number) => {
    handleHideMenuForPick();
    if (type === "substitute") {
      dispatch(actionSubstitution(element));
    } else if (type === "makeCaptain") {
      dispatch(changeCaptain(element));
      createInteractionData({
        contentTitle: "edit lineup",
        interactionId: "nba-fantasy-game:make-captain:button",
        interactionText: t("myTeam.menuDialog.makeCaptain", "Make Captain"),
      });
    }
  };

  const showDialog = (element: IElement) => {
    dispatch(showElementSummary(element.id));
    handleHideMenuForPick();
  };

  const renderMenu = () => {
    const pick = pickForMenu;

    if (!pick) {
      return null;
    }
    const element = elementsById[pick.element];
    const status = pick.subStatus;
    const startMax = rules.squad_squadplay;

    const showCaptButton =
      activeChip?.name === "phcapt"
        ? true
        : chipInPlayName === "phcapt"
          ? true
          : false;

    return (
      <Dialog closeDialog={handleHideMenuForPick}>
        <Dialog.Header closeDialog={handleHideMenuForPick}>
          {`${element.first_name} ${element.second_name}`}
        </Dialog.Header>
        <Dialog.Body>
          <PlayerActions>
            {status.match(/^(target|)$/) && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  fullwidth="true"
                  variant="secondary"
                >
                  {t("myTeam.menuDialog.switch", "Switch")}
                </Button>
              </DialogButtonItem>
            )}
            {status === "instigator" && (
              <DialogButtonItem>
                <Button
                  onClick={() => action("substitute", pick.element)}
                  fullwidth="true"
                >
                  {t("myTeam.menuDialog.cancel", "Cancel")}
                </Button>
              </DialogButtonItem>
            )}
            {!status &&
              pick.position <= startMax &&
              !pick.is_captain &&
              showCaptButton && (
                <DialogButtonItem>
                  <Button
                    onClick={() => action("makeCaptain", pick.element)}
                    fullwidth="true"
                    variant="primary"
                  >
                    {t("myTeam.menuDialog.makeCaptain", "Make Captain")}
                  </Button>
                </DialogButtonItem>
              )}
            <DialogButtonItem>
              <Button
                onClick={() => showDialog(element)}
                fullwidth="true"
                variant="secondary"
              >
                {t("myTeam.menuDialog.viewInfo", "View Information")}
              </Button>
            </DialogButtonItem>
          </PlayerActions>
        </Dialog.Body>
      </Dialog>
    );
  };

  useEffect(() => {
    dispatch(fetchMyTeam());
    dispatch(fetchEntrySummary(player.entry));
    createPageViewData("edit lineup");
  }, [dispatch, player.entry]);

  const renderChipAction = (c: IPotentialChip) => {
    switch (c.status_for_entry) {
      case "available":
      case "unavailable":
        return (
          <Button
            onClick={() => dispatch(proposeAvailableChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            variant="secondary"
            fullwidth="true"
          >
            {t("myTeam.play", "Play")}
          </Button>
        );
      case "proposed":
        return (
          <Button
            onClick={() => dispatch(cancelProposedChip(c.name))}
            fullwidth="true"
            variant="secondary"
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "active":
        return (
          <Button
            onClick={() => dispatch(cancelActiveChip(c.name))}
            fullwidth="true"
            variant="secondary"
          >
            {t("myTeam.cancel", "Cancel")}
          </Button>
        );
      case "cancelled":
        return (
          <Button
            onClick={() => dispatch(restoreCancelledChip(c.name))}
            disabled={Boolean(chipInPlayName)}
            fullwidth="true"
            variant="secondary"
          >
            {t("myTeam.restore", "Restore")}
          </Button>
        );
      case "played":
        if (!entry) {
          return (
            <>
              <div>{t("myTeam.played", "Played")}</div>
              <div>
                {getPrefixedEventShortName(
                  eventsById[c.played_by_entry[0]].name,
                )}
              </div>
            </>
          );
        }
        return (
          <ChipLink to={`/entry/${entry.id}/event/${c.played_by_entry[0]}`}>
            <ChipLinkWrap>
              <div>{t("myTeam.played", "Played")}</div>
              <div>
                {getPrefixedEventShortName(
                  eventsById[c.played_by_entry[0]].name,
                )}
              </div>
              <ChipLinkArrow />
            </ChipLinkWrap>
          </ChipLink>
        );

      default:
        return "";
    }
  };

  const handleSaveTeam = () => {
    createInteractionData({
      contentTitle: "edit lineup",
      interactionId: "nba-fantasy-game:save-team:button",
      interactionText: t("myTeam.saveTeam", "Save Your Team"),
    });
    dispatch(saveMyTeam());
  };

  if (!entry || !picks.length) {
    return null;
  }

  // Create a new function on each render as fixtures could have changed and
  // need to ensure a render of connected subcomponents
  const _renderPickValue = renderPickValue({
    elementsById,
    teamsById,
    fixturesForNextEventByTeam,
  });
  const benchHeading: Record<string, React.ReactNode> = {
    5: "",
    6: "",
    7: "",
    8: "",
    9: "",
  };
  const chipDetails = getAllChipDetails(t);
  const phaseCaptainChip = chips.find((c) => c.name === "phcapt");
  const activePhaseEvent = now ? now.id : 1;
  const activePhase = phases.find(
    (p) =>
      p.id > 1 &&
      p.start_event <= activePhaseEvent &&
      p.stop_event >= activePhaseEvent,
  );
  const nextPhase = activePhase
    ? phases.find((ph) => ph.id === activePhase.id + 1)
    : null;
  let daysLeft = now && activePhase ? activePhase.stop_event - now.id : 0;
  if (now && daysLeft === 0 && nextPhase) {
    daysLeft = nextPhase.stop_event - now.id;
  }

  return (
    <Wrapper>
      <Main>
        <DeadlineBarWrap>
          {nextEvent && (
            <DeadlineBar
              deadlineISO={formatRawAsISO(nextEvent.deadline_time)}
              deadlineLocal={formatRawAsLocalI18n(
                nextEvent.deadline_time,
                dateLocales[i18n.language],
              )}
              headingText={nextEvent.name}
            />
          )}
        </DeadlineBarWrap>
        <Tabs centered>
          <TabPanel label={t("myTeam.pitchView", "Court View")} link="pitch">
            <Box mb="4px">
              <TeamElementGroup
                title={t("myTeam.startersN", "Starting 5")}
                isHiddenTitle={false}
              >
                <PitchFormation
                  chipName={chipAllPlayName}
                  formation={formation}
                  picks={picks}
                  renderDreamTeam={renderDreamTeam}
                  renderElementMenu={handleShowMenuForPickElement}
                  renderPickValue={_renderPickValue}
                />
              </TeamElementGroup>
            </Box>
            {activeChip?.chip_type === "transfer" ? (
              <Box my={2}>
                <Alert type="info">
                  <p>
                    {t("myTeam.alerts.transferChip", "{{ chipName }} Active", {
                      chipName: chipDetails[activeChip.name as ChipName].name,
                    })}
                  </p>
                </Alert>
              </Box>
            ) : (
              phaseCaptainChip && (
                <>
                  <ChipSectionWrap>
                    <ChipSection>
                      <Tooltip
                        content={
                          chipDetails[phaseCaptainChip.name as ChipName]
                            .description
                        }
                      >
                        <HeadingInfo>
                          <ChipHeading>
                            {
                              chipDetails[phaseCaptainChip.name as ChipName]
                                .name
                            }
                          </ChipHeading>
                          <InfoIcon />
                        </HeadingInfo>
                      </Tooltip>
                      <ButtonHeight>
                        {renderChipAction(phaseCaptainChip)}
                      </ButtonHeight>
                      {now && (
                        <>
                          <ChipStatus
                            status={phaseCaptainChip.status_for_entry}
                            daysLeft={daysLeft}
                          />
                        </>
                      )}
                    </ChipSection>
                  </ChipSectionWrap>
                </>
              )
            )}
            <Box mb={4}>
              <TeamElementGroup
                title={t("myTeam.substitutesn", "Bench")}
                isBench={true}
              >
                <BenchElements>
                  {range(rules.squad_squadplay, rules.squad_squadsize).map(
                    (i) => (
                      <BenchUnit
                        key={i}
                        chipName={chipAllPlayName}
                        heading={benchHeading[i]}
                        pick={picks[i]}
                        positionOnBench={i - rules.squad_squadplay + 1}
                        renderElementMenu={() =>
                          handleShowMenuForPickElement(picks[i].element)
                        }
                        renderDreamTeam={renderDreamTeam}
                        renderPickValue={_renderPickValue}
                      />
                    ),
                  )}
                </BenchElements>
              </TeamElementGroup>
            </Box>
          </TabPanel>
          <TabPanel label={t("myTeam.listView", "List View")} link="list">
            <Box mb={4} mx="-1px">
              <TableWrap>
                <MyTeamTable
                  title={t("myTeam.starters", "Starters")}
                  picks={picks.slice(0, rules.squad_squadplay)}
                  renderElementMenu={handleShowMenuForPickElement}
                />

                <MyTeamTable
                  title={t("myTeam.substitutesn", "Bench")}
                  picks={picks.slice(rules.squad_squadplay)}
                  renderElementMenu={handleShowMenuForPickElement}
                />
              </TableWrap>
            </Box>
            {activeChip?.chip_type === "transfer" ? (
              <Box my={2}>
                <Alert type="info">
                  <p>
                    {t("myTeam.alerts.transferChip", "{{ chipName }} Active", {
                      chipName: chipDetails[activeChip.name as ChipName].name,
                    })}
                  </p>
                </Alert>
              </Box>
            ) : (
              phaseCaptainChip && (
                <>
                  <ChipSectionWrap>
                    <ChipSection>
                      <Tooltip
                        content={
                          chipDetails[phaseCaptainChip.name as ChipName]
                            .description
                        }
                      >
                        <HeadingInfo>
                          <ChipHeading>
                            {
                              chipDetails[phaseCaptainChip.name as ChipName]
                                .name
                            }
                          </ChipHeading>
                          <InfoIcon />
                        </HeadingInfo>
                      </Tooltip>
                      <ButtonHeight>
                        {renderChipAction(phaseCaptainChip)}
                      </ButtonHeight>
                      {now && (
                        <>
                          <ChipStatus
                            status={phaseCaptainChip.status_for_entry}
                            daysLeft={daysLeft}
                          />
                        </>
                      )}
                    </ChipSection>
                  </ChipSectionWrap>
                </>
              )
            )}
          </TabPanel>
        </Tabs>
        <SquadActionBar>
          <Button
            onClick={handleSaveTeam}
            disabled={
              (!changed && !chipsChanged) || !valid || savingState === "saving"
            }
            fullwidth="true"
          >
            {t("myTeam.saveTeam", "Save Your Team")}
          </Button>
        </SquadActionBar>
        {savingState === "saved" ? (
          <Box my={2}>
            <Alert type="success">
              {t("myTeam.alerts.teamSaved", "Your team has been saved.")}
            </Alert>
          </Box>
        ) : (
          <>
            <Box mx={2} mb={4}>
              <Note>
                {t(
                  "myTeam.explain.p1",
                  "Only your starting 5 players will score points. Move players with a fixture into the starting 5.",
                )}{" "}
                <br />
                {t(
                  "myTeam.explain.p2",
                  "If your starter doesn't play, automatic substitutions will be made in the priority order selected below.",
                )}{" "}
                <br />
                {t(
                  "myTeam.explain.p3",
                  "To change your captain use the menu which appears when clicking on a player.",
                )}
              </Note>
            </Box>
          </>
        )}
        {renderMenu()}
        <Fixtures />
        <NbaNewsProvider numberOfArticles={10} />
      </Main>
      <Secondary>
        <Entry entryId={entry.id} />
      </Secondary>
    </Wrapper>
  );
};

export default withTranslation()(MyTeam);
